export function createPrivateOfficeCancellationRegistry({ onCancel = null } = {}) {
  const controllers = new Map();

  return Object.freeze({
    register(callId) {
      if (typeof callId !== 'string' || !callId) {
        throw new TypeError('A private Office call ID is required');
      }
      controllers.get(callId)?.abort();
      const controller = new AbortController();
      controllers.set(callId, controller);
      return controller.signal;
    },
    cancel(callId, reason = 'cancelled') {
      const controller = controllers.get(callId);
      if (!controller) return false;
      try { onCancel?.(callId, reason); } catch (_) { /* cancellation must continue */ }
      controller.abort(reason);
      return true;
    },
    cancelAll(reason = 'cancelled') {
      const callIds = [...controllers.keys()];
      for (const callId of callIds) this.cancel(callId, reason);
      return callIds;
    },
    release(callId) {
      controllers.delete(callId);
    },
    has(callId) {
      return controllers.has(callId);
    },
    hasAny() {
      return controllers.size > 0;
    },
  });
}

export default { createPrivateOfficeCancellationRegistry };
